(function () {
  var grids = Array.prototype.slice.call(document.querySelectorAll('[data-scroll-reveal-grid]'));
  var sections = Array.prototype.slice.call(document.querySelectorAll('[data-scroll-reveal-section]'));
  var targets = grids.concat(sections);
  if (!targets.length) return;

  function revealAll() {
    targets.forEach(function (target) {
      target.classList.add('is-revealed');
    });
  }

  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motionQuery.matches) {
    revealAll();
    return;
  }

  grids.forEach(function (grid) {
    Array.prototype.forEach.call(grid.children, function (item, index) {
      item.style.setProperty('--scroll-reveal-index', index);
    });
  });

  sections.forEach(function (section) {
    Array.prototype.forEach.call(section.querySelectorAll('[data-scroll-reveal-item]'), function (item, index) {
      item.style.setProperty('--scroll-reveal-index', index);
    });
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px 10% 0px', threshold: 0.01 }
  );

  targets.forEach(function (target) {
    observer.observe(target);
  });
})();
